import React, {  useEffect, useState} from "react";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import Message from "../LoadingError/Error";
import Loading from "../LoadingError/Loading";
import Toast from "../LoadingError/Toast";
import axios from "axios";
import { BASE_URL } from "../../api/baseConfig";
const ToastObjects = {
  pauseOnFocusLoss: false,
  draggable: false,
  pauseOnHover: false,
  autoClose: 2000,
};
const CreatePlatformsRef = (platInfo) => {
  const [mainRefInfo,setMainRefInfo]=useState(null)
  const history = useHistory();
  const [maincontentType, setMaincontentType] = useState("");
  const [rowNumber, setRowNumber] = useState(0);

  const [platform, setPlatform] = useState("");
  const [catalog, setCatalog] = useState("");
  const [platforms, setPlatforms] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [catalogs, setCatalogs] = useState([])
  const [contentTypes, setContentTypes] = useState([])
  
  useEffect(()=>{
    if(platInfo.platformRef.platform){
      setPlatform(platInfo.platformRef.platform)
      setCatalog(platInfo.platformRef.catalog)
      setMaincontentType(platInfo.platformRef.type)
      setMainRefInfo(platInfo)
      setRowNumber(platInfo.platformRef.row_number)
    }
  },[platInfo])

  const submitHandler = (e) => {
    e.preventDefault();
    const token = localStorage.getItem("userInfo").token
    setLoading(true)
    axios.post(`${BASE_URL}/api/platformref/add`,{ catalog:catalog.id, content_type:maincontentType.id, platform:platform.id,row_number:rowNumber },{
      headers:{
        "Authorization": `${token}`
      }
    }).then((res)=>{
      toast.success("Platform Added", ToastObjects);
      setMainRefInfo(null)
      setCatalog("");
      setMaincontentType("");
      setPlatform("");
      setRowNumber(0);
      history.replace("/platform-ref");
      setLoading(false)
    })
    .catch((err)=>{
      setError(err.response.data.message)
      setLoading(false)
    })
  };
  const submitHandlerEdit = (e) => {
    const token = localStorage.getItem("userInfo").token
    setLoading(true)
    axios.put(`${BASE_URL}/api/platformref/update/${platInfo.platformRef.id}`,{ catalog:catalog.id, content_type:maincontentType.id, platform:platform.id,row_number:rowNumber },{
      headers:{
        "Authorization": `${token}`
      }
    }).then((res)=>{
      toast.success("Platform Updated", ToastObjects);
      setMainRefInfo(null)
      setCatalog("");
      setRowNumber(0);
      setMaincontentType("");
      setPlatform("");
      history.replace("/platform-ref");
      setLoading(false)
    })
    .catch((err)=>{
      setError(err.response.data.message)
      setLoading(false)
    })

  };
  useEffect(() => {
    (async()=>{
      try {
        setLoading(true)
        const res = await axios.get(`${BASE_URL}/api/platform/getall`)
        setPlatforms(res.data)
        const res2 = await axios.get(`${BASE_URL}/api/catalogs/getall/AZ`)
        setCatalogs(res2.data)
        const res3 = await axios.get(`${BASE_URL}/api/contenttype/getall/AZ`)
        setContentTypes(res3.data)
        setLoading(false)
      } catch (error) {
        setError(error.response.data.message)
        setLoading(false)
      }
    })()
  }, []);


  const cancelEventHandler=()=>{
      setMainRefInfo(null)
      setPlatform("");
      setCatalog("");
      setRowNumber(0);
      setMaincontentType("");
    }
  
  const handleGetCatalog =(value)=>{
    axios.get(`${BASE_URL}/api/catalogs/getall/AZ?q=${value}`).then((res)=>{
      setCatalogs(res.data)
    })
  }
  const handleChangeCatalogs = (option) => {
    setCatalog(option)
  };
  return (
    <>
      <Toast />
      <div className="col-md-12 col-lg-4">
        <form
          onSubmit={platInfo.platformRef.platform ? submitHandlerEdit : submitHandler}
        >
          {error && <Message variant="alert-danger">{error}</Message>}
          {loading && <Loading />}
          <div className="mb-4">
                          <label type="number" className="form-label">Sıra nömrəsi</label>
                          <input required={true} value={rowNumber} onChange={(e)=>setRowNumber(Number(e.target.value))} className="form-control" placeholder="0"/>
                        </div>
                        <div className="mb-4">
                          <label className="form-label">Platforms</label>
                          <Select
                            onChange={(e) => setPlatform({id:e.id,name:e.name})}
                            id="platform"
                            options={platforms}
                            defaultValue={platform}
                            value={platform}
                            required={true}
                            getOptionLabel={(opt) => opt.name}
                            getOptionValue={(opt) => opt.id}
                          />
                        </div>
                        <div className="mb-4">
                          <label className="form-label">Catalogs</label>
                          <div className="mb-4">
                            {catalogs && (
                              <Select
                                onChange={handleChangeCatalogs}
                                onInputChange={handleGetCatalog}
                                options={catalogs.data}
                                value={catalog}
                                required={true}
                                getOptionLabel={(opt) => opt.name}
                                getOptionValue={(opt) => opt.id}
                              />
                            )}
                          </div>
                        </div>
                        <div className="mb-4">
                          <label className="form-label">Type</label>
                          <Select
                            onChange={(e) => setMaincontentType({id:e.id,name:e.name})}
                            id="platform"
                            options={contentTypes}
                            defaultValue={maincontentType}
                            value={maincontentType}
                            getOptionLabel={(opt) => opt.name}
                            getOptionValue={(opt) => opt.id}
                            required={true}
                          />
                        </div>
          <div className="d-grid">
            {mainRefInfo ? (
              <>
                <button className="btn btn-warning py-3 mb-3" type="submit">
                  Edit Platform
                </button>
                <button
                  onClick={cancelEventHandler}
                  className="btn btn-secondary py-3"
                  type="button"
                >
                  Cancel
                </button>
              </>
            ) : (
              <button type="submit" className="btn btn-primary py-3">
                Create platform
              </button>
            )}
          </div>
        </form>
      </div>
    </>
  );
};

export default CreatePlatformsRef;
